export const onMessageReceive = (event, id) => {
  const iframe = document.getElementById(id);
  // eslint-disable-next-line no-prototype-builtins
  if (iframe && 'height' in event.data) {
    iframe.setAttribute('style', `height: ${event.data.height}px`);
  }
};

const setIframeHeight = (iframe) => {
  iframe.contentWindow.postMessage('height', '*');
};

export const queryForHeight = (id) => {
  let resizeTimeout;

  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const iframe = document.getElementById(id);
    if (iframe) {
      setIframeHeight(iframe);
    }
  }, 50);
};

const getUtmParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const allowedUtmAttributes = ['utm_source', 'utm_medium'];

  return allowedUtmAttributes.reduce((acc, param) => {
    const value = searchParams.get(param);

    return {
      ...acc,
      ...(value && { [param]: value }),
    };
  }, {});
};

export const postUtmParamsToIframe = (id: string) => {
  const iframe = document.getElementById(id) as HTMLIFrameElement;

  if (!iframe) {
    return;
  }

  const utmParams = getUtmParams();

  iframe.contentWindow!.postMessage(
    {
      type: 'utm',
      data: utmParams,
    },
    '*'
  );
};
